// Generated by ReScript, PLEASE EDIT WITH CARE


function removeWhitespaces(str) {
  return str.replace(/[ ]/g, "");
}

export {
  removeWhitespaces ,
}
/* No side effect */
